<template>
  <div v-if="getPermission.settings.view">  

    <app-version-form ref="AppVersionForm" mode="WEBCREATE"/>
    <app-version-form ref="AppVersionFormUpdate" mode="WEBUPDATE"/>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">



          <!-- <div  v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <md-field>
                <label size="lg" class = "textlabel" for="appName" >Web Name</label>
                  <md-select v-model="searchRequest.appName">
                  <md-option value="WEB">Web</md-option>
                </md-select>
              </md-field>
            </div>
          </div> -->


          <div v-if="getPermission.settings.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/app/list']">
              <callingApiCenter path=" /api/w/app/list" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-appVersion md-primary md-raised" ><span class="icons-center material-icons">beach_access</span>Search</md-button>
                <md-button class="md-raised custButton" @click="doClear"><span class="icons-center material-icons">fastfood</span>Clear</md-button>
                <md-button class="md-raised custButton md-primary" @click="doNew"><span class="icons-center material-icons">adb</span>New</md-button>
                <md-button class="md-raised custButton md-primary" :disabled="!canEdit" @click="doChange"><span class="icons-center material-icons">bug_report</span>Modify</md-button> 
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>


    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                        <!-- <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                        <md-tooltip md-direction="top">All</md-tooltip> -->
                      </th>
                      <th class="header-cell center w2" v-on:click="sortFunction('appName')">app</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('ver')">ver</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('status')">status</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('releaseDate')">releaseDate</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdAt')">createdAt</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">CreatedBy</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedAt')">updatedAt</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('updatedBy')">updatedBy</th>
                      <th class="header-cell excelBoxNote w15" v-on:click="sortFunction('releaseNote')">releaseNote</th>
                    </tr>  
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <md-checkbox v-model="item.selected"></md-checkbox>
                      </td>
                      <td class="body-cell excelBox w2">{{item.appName}}</td> 
                      <td class="body-cell excelBox w5">{{item.ver}}</td> 
                      <td class="body-cell excelBox w4">{{item.status }}</td>
                      <td class="body-cell excelBox w5">{{item.releaseDate  | date}}</td>
                      <td class="body-cell excelBox w5">{{item.createdAt  | date}}</td>     
                      <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBoxNote w15">{{item.releaseNote}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

.excelBoxNote {
  width: 50px;
}


.icons-center {
      vertical-align: bottom;
      margin-right: 10px;
      color: rgb(165, 236, 227);
      font-size: 25px;
  }

.lable-center {
    vertical-align: bottom;
    margin-left: 20px;
    font-size: 20px;
    color: #010855;
}

.data-center {
    vertical-align: bottom;
    font-size: 20px;
    color: #0b21e9;
}

  .inputBox {
      border: 1px solid #cacbcc;
      border-radius: 5px;
      color: #29303b;
      font-size: 18px;
      height: auto;
      line-height: 1.5em;
      padding: 5px 5px 5px 5px;
      margin-top: 5px;
  }

  .selected {
      background: rgb(217, 204, 255);
  }

  .center {
      text-align: center;
  }

  .custButton {
      margin: 10px;
      width: 120px;
      height: 40px;
      line-height:40px;
      font-size: 0.8rem;
  }

  .custSearchBar{
      margin: 10px;
      width: 200px;
      height: 40px;
      line-height:40px;
      font-size: 0.9rem;
      color: blue;
  }

  .custButtonRight {
      margin: 10px;
      width: 100px;
      height: 40px;
      float : right;
      color: green;
  }
</style>


<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import api from "../api";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import AppVersionForm from '../components/AppVersionForm.vue';
  import moment from 'moment';


  const getInitSearch = () => ({
    mode: "list",
    appName: "WEB",
    selected: false,

  });
  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      active: true,
      items: [],
      sortStatus: true,
      filter:"",
      selectAll: false,
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
      AppVersionForm,
    },

    watch: {
      getappVersionList(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
        'getPermission',
        'getUserProfile',
        'getMasterDataName',
        'getRole',
        'getappVersionList',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.appName).includes(term) ||
                  this.includeNull(row.ver).includes(term) ||
                  this.includeNull(row.env).includes(term) ||
                  this.includeNull(row.status).includes(term);
        })
      },

      canEdit() {
              return this.getSelectedItems.length === 1;
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
       

    },



    async mounted() {

      this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getappVersionList);
      
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },
      mouseLeave: function() {
        this.active = !this.active;
      },


      sortFunction(sortFiled){
        const sorted = _(this.items).sortBy(sortFiled);
        console.log(this.sortStatus)
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus)
        {
            this.items = sorted;
        }
        else
        {
            this.items = sorted.reverse();
        }
      },

      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
      },
      
      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource)) ;
        items.forEach((it) => {
          it.selected ;
        });
        this.items = items;         
      },
     

      doNew() {
        
        this.$refs.AppVersionForm.openDialog();
      },

      doChange() {
        const request = this.getSelectedItems[0];
        this.$refs.AppVersionFormUpdate.openDialog(request);
      },
      doSearch() {
        this.active = true;
        this.selectAll = false; 
        this.$store.dispatch('appVersionList', this.searchRequest);
       },

      doClear(){
        // this.filter = "";
        this.searchRequest = getInitSearch();
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      includeNull(field){
            return field==null ? '' : field;
      },

  },
}
</script>